import React from 'react';
import { Box } from '@mui/material';
import Section from '../../../shared/Section/Section';
import { AdvantageCard } from './AdvantageCard';

import partTimeAdvantage1 from '../../FormatComparison/images/part-time-advantage-1.png';
import partTimeAdvantage2 from '../../FormatComparison/images/part-time-advantage-2.png';
import partTimeAdvantage3 from '../../FormatComparison/images/part-time-advantage-3.png';
import partTimeAdvantage4 from '../../FormatComparison/images/part-time-advantage-4.png';
import partTimeAdvantage5 from '../../FormatComparison/images/part-time-advantage-5.png';

const ADVANTAGES = [
  {
    text: 'Знания идентичны курсу\nв формате буткемп',
    imageSrc: partTimeAdvantage1,
  },
  {
    text: '\nИнтенсивной работы\nс преподавателями онлайн',
    imageSrc: partTimeAdvantage2,
  },
  {
    text: 'Можно совмещать\nс работой!',
    imageSrc: partTimeAdvantage3,
  },
  {
    text: 'Учёба без стресса\nи без потери дохода!',
    imageSrc: partTimeAdvantage4,
  },
  {
    text: 'Учеба в удобное время —\nпо будням вечером\nи в субботу днём',
    imageSrc: partTimeAdvantage5,
  },
];

const PartTimeAdvantages = () => {
  return (
    <Section
      title="Преимущества парт-тайма"
      withoutBg
      customStyles={{
        '& h2': {
          marginBottom: '32px',
        },
        padding: {
          xs: '32px 0',
          md: '40px 0 80px 0',
        },
      }}
    >
      <Box
        sx={{
          maxWidth: { xs: '328px', md: '1320px' },
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: 3,
        }}
      >
        {ADVANTAGES.map((advantage, index) => (
          <Box
            key={index}
            sx={{
              width: { xs: '100%', md: '420px' },
              flexShrink: 0,
            }}
          >
            <AdvantageCard
              text={advantage.text}
              imageSrc={advantage.imageSrc}
            />
          </Box>
        ))}
      </Box>
    </Section>
  );
};

export default PartTimeAdvantages;
